import { Api, ApiUrl, pageApi } from "../../services";
import { actionTypes, mutationTypes } from "@/store/dashboard/types";
const SECTIONS_DATA_FROM_API = ["faqs", "blog", "changelog", "recentPages", "newTemplates", "topIntegrations", "banner"];
import store from "../index"
import { getThemeId } from "@/modules/Instant/utils";

const transformPageType = originalType => {
  if (!originalType) return "";
  switch (originalType) {
    case "subpages":
      return "template-page";
    case "articlepages":
      return "template-article";
    case "homepages":
      return "template-index";
    case "productpages":
      return "template-product";
    case "collectionpages":
      return "template-collection";
      case "template-page":
        return "subpages";
      case "template-article":
        return "articlepages";
      case "template-index":
        return "homepages";
      case "template-product":
        return "productpages";
      case "template-collection":
        return "collectionpages";
    default:
      return originalType;
  }
};

const updateRecentPagesV7 = async ({ themeId, dispatch, rootState }) => {
  let originPageTypes = ["ARTICLE", "BLOG", "COLLECTION", "PRODUCT", "STATIC"];
  const { shopInfo } = rootState.account|| {};
  if (shopInfo && shopInfo.shopType && shopInfo.shopType.isGemPagesMixed) {
    originPageTypes = originPageTypes.concat(['GP_INDEX', 'GP_PRODUCT', 'GP_COLLECTION', 'GP_ARTICLE'])
  }
  const result = await pageApi.getThemePageApi({
    first: 5,
    themeID: themeId,
    orderBy: {
      field: 'UPDATED_AT',
      direction: 'DESC',
    },
    where: {
      typeNotIn: originPageTypes
    },
    themePageMetasWhere: {
      keyIn: ['capture_page_thumbnail', 'global_layout', 'last_action'],
    },
  })

  const recentPages = result?.data?.themePages?.edges.map((v) => {
    const themePagesMetas = v?.node?.themePageMetas?.edges;
    let metaThumbnail = '';
    let lastAction = '';
    if (themePagesMetas.length) {
      metaThumbnail = themePagesMetas.find(item => item.node?.key == "capture_page_thumbnail")?.node.value || null;
      lastAction = themePagesMetas.find(item => item.node?.key == "last_action")?.node.value || null;
    }
    return {
      id: v?.node?.id,
      status: v?.node?.status,
      default: v?.node?.default,
      thumbnailUrl: v?.node?.theme?.thumbnail,
      metaThumbnail: metaThumbnail,
      title: v?.node?.name,
      type: v?.node?.type,
      updatedAt: v?.node?.updatedAt,
      handle: v?.node?.handle,
      lastAction,
      isTemplateV7: true,
      isPublished: v?.node?.status == 'PUBLISHED'
    }
  }).flat();

  dispatch("fetchRecentPages", { newRecentPages: recentPages, isTemplateV7 : true });
}

const updateNewTemplatesV7 = async ({ state }) => {
  const result = await pageApi.getThemePagesGlobal({ 
    first: 9,
    orderBy: {
      field: 'CREATED_AT',
      direction: 'DESC',
    },
  })
  const newTemplates = result?.data?.themePagesGlobal?.edges.map((v) => v.node);
  state['newTemplates'] = newTemplates;
}

const updateStateData = ({ state, rootGetters, rootState, data, dispatch }) => {
  const { shopInfo } = rootState.account|| {};

  const saveInDashboardModule = ["faqs", "changelog", "newTemplates"];
  const allSections = [...saveInDashboardModule, "banner", "blog", "topIntegrations", "support", "quickStartGuide", "recentPages"];

  if (!shopInfo.shopType.isGemPagesV6) {
    const index = allSections.indexOf('quickStartGuide');
    allSections.splice(index, 1);
  }

  const sectionsOrders = {
    left: [],
    right: []
  };

  if (data["topIntegrations"] && data["topIntegrations"].items) {
    let list = data["topIntegrations"].items;
    list = list.map(item => {
      try {
        const newItem = item;
        const metas = JSON.parse(item.data_attr);
        newItem.metas = metas;
        newItem.data_attr = undefined;
        return newItem;
      } catch (error) {
        return item;
      }
    });
    state.topIntegrations = list;
  }

  if (data.banner?.items) {
    const plan = rootGetters["account/shopPlan"];
    const banners = data.banner?.items.filter(item => item.settings[plan]);
    if (banners.length == 0 && data.dashboardSettings) {
      data.dashboardSettings.banner.show = false;
      data.dashboardSettings.banner.disabled = true;
    }

    state.banner = banners;
  }

  if (data.blog?.items) {
    // const plan = rootGetters["account/shopPlan"];
    const blogs = data.blog?.items
    if (blogs.length == 0 && data.dashboardSettings) {
      data.dashboardSettings.blog.show = false;
      data.dashboardSettings.blog.disabled = true;
    }
    state.blog = blogs;
  }

  if (data.recentPages?.items && !shopInfo.shopType.isGemPagesV7) {
    dispatch("fetchRecentPages", { newRecentPages: data.recentPages.items });
  }

  saveInDashboardModule.forEach(sectionName => {
    if (shopInfo.shopType.isGemPagesV7 && sectionName === 'newTemplates') return;
    if (data[sectionName] && data[sectionName].items) {
      state[sectionName] = data[sectionName].items;
    }
  });

  if (data.dashboardSettings) {
    const settings = data.dashboardSettings;

    allSections.forEach(sectionName => {
      if (settings[sectionName]) {
        if (!settings[sectionName].disabled) {
          settings[sectionName].disabled = false;
        }
        settings[sectionName].name = sectionName;

        if (settings[sectionName].type == "left") {
          sectionsOrders.left.push(settings[sectionName]);
        } else {
          sectionsOrders.right.push(settings[sectionName]);
        }
      }
    });

    const sortSections = (section1, section2) => {
      return section1.order - section2.order;
    };

    sectionsOrders.left.sort(sortSections);
    sectionsOrders.right.sort(sortSections);

    state.sectionsOrders = sectionsOrders;
  }
};

const actions = {
  [actionTypes.FETCH_DYNAMIC_TRIGGER_PRICING]: (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.get(ApiUrl.base.pricing.get.trigger);
        store.commit(mutationTypes.SET_DYNAMIC_TRIGGER_PRICING, res.data)
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
  [actionTypes.FETCH_DYNAMIC_CONTENT_PRICING]: (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.get(ApiUrl.base.pricing.get.content);
        store.commit(mutationTypes.SET_DYNAMIC_CONTENT_PRICING, res.data)
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
  [actionTypes.SET_VIEW_COMMUNITY_META]: async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.post(ApiUrl.base.assignment.shopMeta, {
          key: 'view-community',
          metas: 1,
        });
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
  [actionTypes.FETCH_PAYMENT_INFO]: async (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.get(ApiUrl.base.pricing.get.payment);
        store.commit(mutationTypes.SET_PAYMENT_INFO, res.data)
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
  [actionTypes.GET_COUPON]: async (store, id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const shopifyDomain = store.rootState.account.shopInfo.shopifyDomain;
        const params = {
          id, shop: shopifyDomain, is_embeded_dashboard: true
        }
        const res = await Api.base.post(ApiUrl.base.pricing.getCoupon, params);
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
  async getAllData({ state, rootGetters, rootState, dispatch }, sections = []) {
    const { shopInfo } = rootState.account || {};
    
    if (!shopInfo?.shopType?.isGemPagesV6) {
      await dispatch('account/connectGemPagesV7', 0, { root:true });
      const themeId = await getThemeId();
      updateRecentPagesV7({ themeId, dispatch, rootState });
      if (shopInfo?.shopType?.isGemPagesV7) {
        updateNewTemplatesV7({ state });
      }
    }

    try {
      const res = await Api.base.get(ApiUrl.base.page.getDashboard, {
        params: {
          sections
        }
      });
      if (res && res.data && res.data.status == "success") {
        const data = res.data.data;
        updateStateData({ state, rootGetters, rootState, data, dispatch });
      }
    } catch (err) {
      throw err;
    }
  },
  async putSettings({ state, rootGetters, rootState, dispatch }, payload) {
    try {
      const defaultPayload = state.sectionsOrders;
      if (!payload) {
        payload = defaultPayload;
      }
      const allSections = [...payload.left, ...payload.right];
      const dashboardSettings = {};

      for (let i = 0; i < allSections.length; i++) {
        const item = allSections[i];
        dashboardSettings[item.name] = {
          show: item.show,
          type: item.type,
          order: i
        };
      }

      // tìm thông tin còn thiếu để cập nhật lại data
      const sections = allSections
        .filter(item => {
          if (item.show && (!state[item.name] || !state[item.name].length) && SECTIONS_DATA_FROM_API.indexOf(item.name) !== -1) {
            return true;
          }
          return false;
        })
        .map(item => item.name);

      const putRes = await Api.base.put(ApiUrl.base.page.putDashboardSettings, { dashboardSettings, sections });
      if (putRes && putRes.data.status == "success") {
        const data = putRes.data.data;
        data.dashboardSettings = dashboardSettings;
        updateStateData({ state, rootGetters, rootState, data, dispatch });
      }
    } catch (err) {
      throw err;
    }
  },
  async removeOneRecentPage({ state, dispatch, commit }, { shop, page, type }) {
    let pageType = transformPageType(type);
    if (!pageType.length) {
      pageType = page.type;
    }

    let params = {
      shop: shop,
      pageId: page.gId,
      pageType
    };
    const removePageInState = () => state.recentPages.splice(state.recentPages.indexOf(page), 1)
    try {
      if (page?.isTemplateV7) {
        const themeId = await getThemeId();
        await pageApi.unpublishPagesApi({ themeId, ids: [page.id]});
        await pageApi.deleteThemePageApi(page.id);
        removePageInState()
        await dispatch("getAllData", ["recentPages"]);
        return;
      }

      const res = await Api.base.delete(ApiUrl.base.page.deletePage, {
        params: params
      });
      if (res && res.data && res.data.status == "success") {
        const deletePayload = {
          page: {
            id: page.gId,
          },
          type: type || transformPageType(page.type)
        }
        commit("page/DELETE_PAGE", deletePayload, {root: true});
        if (page.is_published || page.published || page.lastAction === 'pagePublish') {
          store.commit("page/UPDATE_PUBLISHED_COUNT", { count: -1, type });
        }

        removePageInState()
        await dispatch("getAllData", ["recentPages"]);
      } else {
        throw res.data;
      }
    } catch (err) {
      throw err;
    }
  },
  async closeQuickStartGuide({ commit, dispatch }) {
    try {
      await commit("HIDE_START_GUIDE");
      await dispatch("putSettings");
    } catch (err) {
      throw err;
    }
  },
  async getAllDashboardData({ state, dispatch }, needLoading = false) {
    try {
      if (needLoading) {
        state.loading = true;
        const defaultOrders = {
          left: [
            { show: true, type: "left", order: 1, disabled: false, name: "recentPages" },
            { show: true, type: "left", order: 2, disabled: false, name: "newTemplates" }
          ],
          right: [
            { show: true, type: "right", order: 5, disabled: false, name: "banner" },
            { show: true, type: "right", order: 6, disabled: false, name: "blog" },
            { show: true, type: "right", order: 7, disabled: false, name: "changelog" },
            { show: true, type: "right", order: 8, disabled: false, name: "faqs" }
          ]
        };
        state.sectionsOrders = defaultOrders;
      }
      await dispatch("getAllData");
      state.firstCallGetApi = true;
    } catch (error) {
      throw error;
    } finally {
      if (needLoading) {
        state.loading = false;
      }
    }
  },
  async fetchRecentPages({state, rootState}, { newRecentPages, isTemplateV7 = false }) {
    const getPreviewLink = (pageId, pageType) => {
      const shopifyDomain = rootState.account.shopInfo.shopifyDomain;
      const shopId = rootState.account.instantShopId;
      const proxyPath = process.env.VUE_APP_SHOPIFY_PROXY_PATH
      return `http://${shopifyDomain}${proxyPath}?version=v7&shop_id=${shopId}&theme_page_id=${pageId}&page_type=${pageType}`;
    };

    const getViewLiveLink = (themePage) => {
      const shopifyDomain = rootState.account.shopInfo.shopifyDomain;
      switch (themePage.type) {
        case "GP_STATIC":
          return `https://${shopifyDomain}/pages/${themePage.handle}`
        case "GP_INDEX": 
          if (themePage.default) {
            return `https://${shopifyDomain}/`
          }
          return ''
        case "GP_ARTICLE": 
          return `https://${shopifyDomain}/blogs/${themePage.handle}`
      }
    }

    //get page item that doesn't have previewUrl to fetch later
    const noPreviewPages = [];
    newRecentPages = newRecentPages.map(item => {
      if (item.isTemplateV7) {
        item.previewUrl = getPreviewLink(item.id, item.type)
        item.viewliveUrl = getViewLiveLink(item)
      } else {
        let needToFetch = false;
        if (!item.previewUrl) {
          //setup default previewUrl to active computed in component
          item.previewUrl = false;
          needToFetch = true;
        }
        if (!item.viewliveUrl) {
          //setup default viewliveUrl to active computed in component
          item.viewliveUrl = false;
          needToFetch = true;
        }
        if (needToFetch && !item.isTemplateV7) {
          noPreviewPages.push({
            id: item.gId,
            type: item.type
          });
        }
      }
      return item;
    });

    if (!state.recentPages || !state.recentPages.length) {
      state.recentPages = newRecentPages
    } else {
      const newIds = newRecentPages.map(item => item.id);

      let currentRecentPages = state.recentPages.filter((item) => !item.isTemplateV7);
      
      if (isTemplateV7) {
        currentRecentPages = state.recentPages.filter((item) => item.isTemplateV7);
      }
      
      const itemsToRemove = currentRecentPages.filter(item => !newIds.includes(item.id));

      if (itemsToRemove.length) {
        state.recentPages = state.recentPages.filter(item => !itemsToRemove.includes(item));
      }

      const newLength = newRecentPages.length;
      const currentLength = state.recentPages.length;

      for (let index = 0; index < newLength; index++) {
        const newRecentPage = newRecentPages[index];
        let isExist = false;

        for (let index = 0; index < currentLength; index++) {
          const recentPage = state.recentPages[index];

          if (newRecentPage.id === recentPage.id) {
            state.recentPages.splice(index, 1, newRecentPage);
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          state.recentPages.push(newRecentPage)
        }
      }
    }

    if (noPreviewPages.length) {
      const res = await Api.base.post(ApiUrl.base.fetchPreviewLink, {
        pages: noPreviewPages
      });

      if (res.data?.pages) {
        const resPages = res.data.pages;
        resPages.forEach(page => {
          const originalPage = newRecentPages.find(item => item.gId === page.id);
          if (originalPage) {
            originalPage.previewUrl = page.previewUrl;
            originalPage.viewliveUrl = page.viewliveUrl;
          }
        });
      }
    }
  },
  [actionTypes.PRICING_CHARGE_ACTION]: (store, url) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.get(url + '&newDashboardPayment=true');
        resolve(res.data)
      } catch (e) {
        reject(e)
      }
    })
  },
};

export default actions;
